import React from 'react';
import './StatisticsSidebar.css';
import OpalStatsSection from '../../OpalStatsSection/OpalStatsSection';

const StatisticsSidebar = ({ statisticData }) => {

    return (
        <div className='plotting-sidebar'>
            <OpalStatsSection sections={statisticData} />
        </div>
    );
};

export default StatisticsSidebar;
